// src/composables/useNotifications.js

// Assuming 'html' is a Vue component you use for custom toast content.
// Adjust the path based on your actual file structure.
import html from '@/components/toast-html.vue';

// You'll need to import the toast library instance.
// For vue-toastification, you can import useToast if you're using it in a component,
// or get the global instance if it's been properly set up.
// For this example, we'll assume it's globally available via provide/inject or direct import.
import { useToast } from 'vue-toastification';

export function useNotifications() {
    const $toast = useToast(); // Get the toast instance

    const notifySaveSuccess = () => {
        $toast.success("Record saved successfully!", {
            position: "bottom-left",
            timeout: 6000,
            closeOnClick: false,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false
        });
    };

    const notifyUpdateSuccess = () => {
        $toast.success("Record updated successfully!", {
            position: "bottom-left",
            timeout: 6000,
            closeOnClick: false,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false
        });
    };

    const notifyDeleteSuccess = () => {
        $toast.success("Record deleted successfully!", {
            position: "bottom-left",
            timeout: 6000,
            closeOnClick: false,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false
        });
    };

    const notifyError = (message, okButtonCallback = () => { }, onCloseCallback = () => { }) => {
        const content = {
            component: html,
            props: {
                message: message
            },
           
            listeners: {
                okClicked: () => {
                    if (okButtonCallback) {
                        okButtonCallback();
                    }
                }
            }
        };
        $toast.error(content, {
            position: "bottom-left",
            timeout: false,
            closeOnClick: false,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
            draggable: false,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: false,
            rtl: false,
            onClose: () => {
                if (onCloseCallback) {
                    onCloseCallback();
                }
            }
        });
    };

    const notifyInfoError = (message, okButtonCallback = () => { }, onCloseCallback = () => { }) => {
        const content = {
            component: html,
            props: {
                message: message
            },
            listeners: {
                okClicked: () => {
                    if (okButtonCallback) {
                        okButtonCallback();
                    }
                }
            }
        };
        $toast.info(content, {
            position: "bottom-left",
            timeout: false,
            closeOnClick: false,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
            draggable: false,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: false,
            rtl: false,
            onClose: () => {
                if (onCloseCallback) {
                    onCloseCallback();
                }
            }
        });
    };

    return {
        notifySaveSuccess,
        notifyUpdateSuccess,
        notifyDeleteSuccess,
        notifyError,
        notifyInfoError
    };
}